import { Parchment } from 'quill/core';

export default new Parchment.ClassAttributor('height', 'height', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['xsmall', 'medium', 'large'],
});
